var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (0 < _vm.categories.length)?_c('div',{staticClass:"container area_category"},[_c('h2',{staticClass:"garally_title text-center"},[_c('LabelFunMessage',{attrs:{"fcontId":"0","msgkey":"53"}})],1),_c('CategoryTiles')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }